// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"607":"f259c16e","668":"4ed8338d","787":"efcd9f72"}[chunkId] + ".chunk.js";
};